import Navbar from "@/components/Navbar";
import HistoryGrid from "@/components/HistoryGrid";
import api from "@/lib/api";
import { useCallback, useEffect, useState } from "react";

export default function History() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchVideos = useCallback(async () => {
    try {
      const { data } = await api.get("/videos");
      setVideos(data);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchVideos();
  }, [fetchVideos]);

  useEffect(() => {
    const active = videos.some((v) =>
      ["queued", "extracting", "transcribing"].includes(v.status)
    );
    if (!active) return;
    const t = setInterval(fetchVideos, 4000);
    return () => clearInterval(t);
  }, [videos, fetchVideos]);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="max-w-[1600px] mx-auto px-6 lg:px-10 py-10 lg:py-14">
        <div className="mb-8">
          <div className="text-[10px] tracking-[0.3em] text-primary font-mono mb-2">
            // ARCHIVE
          </div>
          <h1 className="text-5xl sm:text-6xl font-black tracking-tighter">
            All sessions
          </h1>
          <p className="text-muted-foreground mt-2">
            Every video you've transcribed. Click one to view segments and download SRT.
          </p>
        </div>
        {loading ? (
          <div className="card-surface p-12 text-center text-muted-foreground font-mono text-sm animate-pulse">
            LOADING…
          </div>
        ) : (
          <HistoryGrid
            videos={videos}
            onDelete={(id) => setVideos((v) => v.filter((x) => x.id !== id))}
          />
        )}
      </main>
    </div>
  );
}
